"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningContainer = exports.InputEditText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.InputEditText = styled_components_1.default.input `
  width: 140px;

  ::placeholder {
    color: #ccc;
  }
`;
exports.WarningContainer = styled_components_1.default.ul `
  margin-left: 15px;
  margin-bottom: 10px;

  > li {
    display: flex;
    align-items: center;
    > span {
      margin-left: 5px;
    }
  }
`;
//# sourceMappingURL=elements.js.map